import { Link, useNavigate } from "react-router-dom";
import { Trash2, ArrowRight } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function Cart() {
  const { items, removeItem, updateQty, total } = useCart();
  const nav = useNavigate();

  if (items.length === 0) {
    return (
      <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-24 text-center" data-testid="cart-empty">
        <h1 className="font-anton text-5xl md:text-7xl uppercase tracking-tighter">Cart's Empty</h1>
        <p className="font-mono text-sm text-muted-foreground mt-4">Go grab some gear.</p>
        <Link to="/shop" className="inline-block mt-8 bg-primary text-primary-foreground font-outfit font-bold uppercase tracking-widest text-sm px-8 py-4 border-2 border-border hover:bg-secondary hover:border-secondary hover:text-white transition-colors">
          Shop Now
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-12 md:py-16" data-testid="cart-page">
      <h1 className="font-anton text-5xl md:text-7xl uppercase tracking-tighter mb-10">Your Cart</h1>
      <div className="grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 border-2 border-border">
          {items.map((it, idx) => (
            <div key={idx} className="flex gap-4 p-4 border-b-2 last:border-b-0 border-border" data-testid={`cart-item-${idx}`}>
              <img src={it.image} alt={it.name} className="w-20 h-24 object-cover border border-border" />
              <div className="flex-1 min-w-0">
                <h3 className="font-outfit font-bold uppercase text-sm">{it.name}</h3>
                <p className="font-mono text-xs text-muted-foreground mt-1">
                  {it.type === "print" ? "Print" : "Tee"}{it.size ? ` · ${it.size}` : ""}{it.color ? ` · ${it.color}` : ""}
                </p>
                <div className="flex items-center gap-3 mt-3">
                  <div className="flex border-2 border-border">
                    <button onClick={() => updateQty(idx, it.qty - 1)} className="w-8 h-8 font-bold hover:bg-muted">−</button>
                    <span className="w-8 h-8 flex items-center justify-center font-mono text-sm border-x-2 border-border">{it.qty}</span>
                    <button onClick={() => updateQty(idx, it.qty + 1)} className="w-8 h-8 font-bold hover:bg-muted">+</button>
                  </div>
                  <button onClick={() => removeItem(idx)} data-testid={`cart-remove-${idx}`} className="text-muted-foreground hover:text-primary">
                    <Trash2 size={18} />
                  </button>
                </div>
              </div>
              <span className="font-anton text-xl">${(it.price * it.qty).toFixed(2)}</span>
            </div>
          ))}
        </div>
        <div className="border-2 border-border p-6 h-fit" data-testid="cart-summary">
          <h2 className="font-outfit font-bold uppercase tracking-widest text-sm mb-5">Order Summary</h2>
          <div className="flex justify-between font-mono text-sm mb-2">
            <span>Subtotal</span><span data-testid="cart-subtotal">${total.toFixed(2)}</span>
          </div>
          <div className="flex justify-between font-mono text-sm mb-2 text-muted-foreground">
            <span>Shipping</span><span>FREE</span>
          </div>
          <div className="flex justify-between font-anton text-2xl border-t-2 border-border pt-4 mt-4">
            <span>Total</span><span data-testid="cart-total">${total.toFixed(2)}</span>
          </div>
          <button
            onClick={() => nav("/checkout")}
            data-testid="checkout-btn"
            className="mt-6 w-full bg-primary text-primary-foreground font-outfit font-bold uppercase tracking-widest text-sm py-4 border-2 border-primary hover:bg-secondary hover:border-secondary transition-colors flex items-center justify-center gap-2"
          >
            Checkout <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
